import React from 'react';
import { useTheme, themes } from '../contexts/ThemeContext';

const ThemeSelector = () => {
  const { currentTheme, changeTheme } = useTheme();

  return (
    <div className="mb-8">
      <h3
        className="text-lg font-semibold mb-3 text-heading border-b pb-2"
        style={{ borderColor: 'var(--color-card-border)' }}
      >
        Color Theme
      </h3>
      <p className="text-sm mb-4 font-lato" style={{ color: 'var(--color-charcoal)', opacity: 0.7 }}>
        Choose a color scheme that suits your reading preference.
      </p>

      <div className="grid grid-cols-2 gap-3">
        {Object.values(themes).map((theme) => {
          const isActive = currentTheme === theme.id;
          return (
            <button
              key={theme.id}
              onClick={() => changeTheme(theme.id)}
              className={`relative p-3 rounded-xl border-2 text-left transition-all duration-200 ${
                isActive ? 'scale-[1.02]' : 'hover:scale-[1.01]'
              }`}
              style={{
                borderColor: isActive ? theme.preview.accent : 'var(--color-card-border)',
                backgroundColor: isActive ? theme.preview.bg : 'var(--color-card-bg)',
                boxShadow: isActive
                  ? `0 0 0 2px var(--color-card-bg), 0 0 0 4px ${theme.preview.accent}`
                  : 'none',
              }}
            >
              {/* Active checkmark */}
              {isActive && (
                <div
                  className="absolute top-2 right-2 w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: theme.preview.accent }}
                >
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}

              {/* Color preview circles */}
              <div className="flex items-center space-x-1.5 mb-2">
                <div
                  className="w-6 h-6 rounded-full border shadow-sm"
                  style={{ backgroundColor: theme.preview.primary, borderColor: 'var(--color-card-border)' }}
                />
                <div
                  className="w-6 h-6 rounded-full border shadow-sm"
                  style={{ backgroundColor: theme.preview.accent, borderColor: 'var(--color-card-border)' }}
                />
                <div
                  className="w-6 h-6 rounded-full border shadow-sm"
                  style={{ backgroundColor: theme.preview.bg, borderColor: 'var(--color-card-border)' }}
                />
              </div>

              {/* Theme name and description */}
              <div className="font-medium text-sm" style={{ color: 'var(--color-charcoal)' }}>{theme.name}</div>
              <div className="text-xs mt-0.5 leading-tight" style={{ color: 'var(--color-charcoal)', opacity: 0.65 }}>{theme.description}</div>

              {/* Mini preview bar */}
              <div className="mt-2 h-1.5 rounded-full overflow-hidden flex">
                <div className="flex-1" style={{ backgroundColor: theme.preview.primary }} />
                <div className="w-1/4" style={{ backgroundColor: theme.preview.accent }} />
                <div className="flex-1" style={{ backgroundColor: theme.preview.primary }} />
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ThemeSelector;